var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.506 29.005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8234-18.6412h-30.05l-5.6375-9.3523c-0.3754-0.6266-1.0543-1.0108-1.7875-1.0115h-29.1667 c-1.1506,0-2.0833,0.928-2.0833,2.0728v53.8545c0,1.1448,0.9327,2.0728,2.0833,2.0728H7.8234 c1.1506,0,2.0833-0.928,2.0833-2.0728v-43.4907C9.9068-17.7132,8.974-18.6412,7.8234-18.6412z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.af436c9582e0bc1b88bc08eaf002d2f3.svg";
export { ForwardRef as ReactComponent };